import { useState, useEffect } from 'react';
import { getSoftwareInfoData } from '../api/software-info-api';
import { ISoftwareReducedInfo } from '../models/software';

export const useSoftwareInfo = () => {
    const [softwareInfo, setSoftwareInfo] = useState<ISoftwareReducedInfo[]>();

    useEffect(() => {
        (async () => {
            const { data: softwareInfoData } = await getSoftwareInfoData();

            if (softwareInfoData) {
                const reducedSoftwareInfo = softwareInfoData.reduce(
                    (reducedInfo: ISoftwareReducedInfo[], infoObj) => {
                        const isInfoObjTypePresent = reducedInfo.find(
                            (obj) => obj.type === infoObj.type
                        );
                        if (isInfoObjTypePresent) {
                            const linksObj = {
                                link: infoObj.link,
                                brand: infoObj.brandToVisualize,
                                type: infoObj.type,
                            };
                            isInfoObjTypePresent.links.push(linksObj);
                        } else {
                            const reducedInfoObj = {
                                links: [
                                    {
                                        link: infoObj.link,
                                        brand: infoObj.brandToVisualize,
                                        type: infoObj.type,
                                    },
                                ],
                                brand: infoObj.brand,
                                type: infoObj.type,
                            };
                            reducedInfo.push(reducedInfoObj);
                        }
                        return reducedInfo;
                    },
                    []
                );
                setSoftwareInfo(reducedSoftwareInfo);
            }
        })();
    }, []);

    return softwareInfo;
};
